import React, { useEffect } from 'react';

/**
 * Relocates a user to an external page like google.ca.
 * @param {{to: string}} props
 */
const ExternalRedirect = ({ to }) => {
  useEffect(() => {
    window.location.replace(to);
  }, []);
  return <div><div id="loader" /></div>;
};

export default ExternalRedirect;
